module.exports = __webpack_public_path__ + "img/728.f2988c2b.png";